<!-- 外部活动（如闯关）浏览倒计时 -->
<template>
  <div class="external-browse-time" v-show="show">
    <img src="@/assets/img/components/browseTime/qixiaohang.png" alt="" />
    <div class="progress"><span :style="{ width: percent + '%' }"></span></div>
    <div class="time">
      <img src="@/assets/img/components/browseTime/bg.png" alt="" />
      <div>
        <p>{{ `浏览${browseSeconds}秒` }}</p>
        <p>{{ rewardText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { completeExternalTask } from '@/utils/externalTask';

const DEFAULT_BROWSE_SECONDS = 15;

export default {
  name: 'ExternalBrowseTime',
  props: {
    // 浏览秒数，可被路由 broswerTime / browseTime 覆盖
    duration: {
      type: Number,
      default: DEFAULT_BROWSE_SECONDS,
    },
    rewardText: {
      type: String,
      default: '即可完成任务',
    },
  },
  data() {
    return {
      show: false,
      success: false,
      endTime: 0,
      browseSeconds: DEFAULT_BROWSE_SECONDS,
      timer: null,
      taskSource: '',
      taskId: '',
    };
  },
  computed: {
    percent() {
      if (!this.browseSeconds) return 0;
      const value = (this.endTime / this.browseSeconds) * 100;
      return value > 100 ? 100 : value;
    },
  },
  watch: {
    $route() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    init() {
      const { taskSource, taskId, broswerTime, browseTime } = this.$route.query;
      this.clearTimer();
      this.show = false;
      this.success = false;
      this.endTime = 0;
      this.taskSource = taskSource || '';
      this.taskId = taskId || '';

      if (taskSource !== 'chuangguan' || !taskId) return;

      const seconds = Number(broswerTime || browseTime || this.duration) || DEFAULT_BROWSE_SECONDS;
      this.browseSeconds = seconds;
      this.show = true;
      this.startTimer();
    },
    startTimer() {
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.endTime < this.browseSeconds) {
          this.endTime += 1;
          return;
        }
        this.endTime = this.browseSeconds;
        this.success = true;
        this.clearTimer();
        this.onBrowseDone();
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async onBrowseDone() {
      const res = await completeExternalTask({
        taskSource: this.taskSource,
        taskId: this.taskId,
      });
      this.$emit('complete', res);
    },
  },
};
</script>

<style lang="scss" scoped>
.external-browse-time {
  position: fixed;
  top: 666px;
  right: 0;
  z-index: 9999;
  width: 160px;
  > img {
    position: relative;
    top: 8px;
    z-index: 10;
    display: block;
    width: 98px;
    margin: 0 auto;
  }
  .progress {
    position: relative;
    width: 160px;
    height: 14px;
    background: #e0e0e0;
    border-radius: 12px;
    > span {
      position: absolute;
      left: 0;
      display: inline-block;
      width: 100px;
      height: 14px;
      background: #ffe800;
      border-radius: 12px;
    }
  }
  .time {
    position: relative;
    img {
      width: 160px;
    }
    > div {
      position: absolute;
      top: 8px;
      width: 100%;
      p {
        padding-bottom: 4px;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        text-align: center;
      }
    }
  }
}
</style>
